const OPTIONS = [
  { id: 'all',       label: 'Raw' },
  { id: 'humans',    label: 'Humans' },
  { id: 'confirmed', label: 'Confirmed' },
  { id: 'hot',       label: '🔥 Hot' },
];

export function FilterToggles({ value, onChange }) {
  return (
    <div className="inline-flex rounded border border-border bg-panel p-1">
      {OPTIONS.map((o) => (
        <button
          key={o.id}
          onClick={() => onChange(o.id)}
          className={`px-3 py-1 text-xs rounded ${
            value === o.id ? 'bg-zinc-700 text-white' : 'text-zinc-400 hover:text-zinc-200'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
